import { render, staticRenderFns } from "./ordersettle.vue?vue&type=template&id=5d294a95&scoped=true"
import script from "./ordersettle.vue?vue&type=script&lang=js"
export * from "./ordersettle.vue?vue&type=script&lang=js"
import style0 from "./ordersettle.vue?vue&type=style&index=0&id=5d294a95&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d294a95",
  null
  
)

export default component.exports